import Vue from 'vue'
import Vuex from 'vuex'
import {
	quanxianlie,
	zongquanxianlie
} from '@/api/quanxian.js';

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		zongquanxian: {
			shu: [],
			lie: [],
			id: []
		},
		quanxian: {
			shu: [],
			lie: [],
			id: []
		},
		yonghu: {},
		//切换语言固定文字
		yuyan: 'EN',
		xinyuyan: {
			EN: {
				shouye: {
					toubu: {
						loginsems: "log in with (SEMS+)",
						// dhforum:"Forum",
						// dhPointsMall:"Points Mall",
						list: [{
							name: 'Forum',
							// url: 'forum'
							url: ''
						}, {
							name: 'Learning Lab',
							url: 'LearningLab'
						}, {
							name: 'GoodWe PLUS+',
							url: 'plus'
						}, {
							name: 'Points Mall',
							url: 'pointsMall'
						}],
						list4: [{
							name: 'Forum',
							// url: 'forum'
							url: ''
						}, {
							name: 'Learning Lab',
							url: 'LearningLab'
						}, {
							name: 'GoodWe PLUS+',
							url: 'plus'
						}, {
							name: 'Points Mall',
							url: 'pointsMall'
						}, {
							name: 'Ambassador',
							url: 'Ambassador'
						}],
						list2: [{
								name: 'Forum',
								// url: '/forum'
								url: ''
							},
							{
								name: 'Learning Lab',
								url: '/LearningLab',
								menulist: [{
									name: 'Video',
									url: '/video'
								}, {
									name: 'Blog',
									url: '/blog'
								}, {
									name: 'Webinar',
									url: '/webinar'
								}
								// , {
								// 	name: 'Calculator',
								// 	url: ''
								// }
								],
							},
							{
								name: 'GoodWe PLUS+',
								url: '/plus'
							}, {
								name: 'Points Mall', 
								url: '/pointsMall'
							}
						],
					},
					contant: {
						Resource: "Learning Lab",
						PopularPost: "Popular Post",
						More: "More",
						PopularGroup: "Popular Group",
						findoutmore: "Find out more",
						postedin: "posted in",
						plusbt1: "JOIN GOODWE PLUS+ NOW!",
						plusbt11: "Program Benefits",
						plusbt112: "The GoodWe PLUS+ membership comes with attractive benefits",
						plusbt113: "Explore More",
						plusbt12: "Qualification Criteria",
						plusbt122: "Step-by-step to GoodWe PLUS+ qualification",
						plusbt123: "Start Now",
						plusbt13: "Frequently Asked Questions",
						plusbt132: "Our FAQ section contains further details about the qualification process",
						plusbt133: "View More",
						plusbt2: "ABOUT GOODWE SOLAR ACADEMY",
						plusbt21: "We are aiming to provide pre-sales support beyond expectation and build an open platform for knowledge sharing and technical training in the PV industry globally.",
						stayin: "STAY IN THE LOOP!",
						stayin2: "Sign up for our newsletter. We won't spam you. Just one update per month.",
						stayin3: "Please enter an email address",
						stayin4: "Submit"
					}
				},
				xinzengde:{
					Username:'User name',
					OrganizationNa:'Organization Na',
					SEMSCode:'SEMS+ Code',
					LastReply:'Last Reply',
					ViewAnswers:'View Answers',
					ExamResults:'Exam Results',
					Back:'Back'
				},
				forum: {
					Search: "Search",
					Post: "Post",
					AllGroups: "All Groups",
					GettingStarted: "Getting Started",
					Official: "Official posts",
					Resource: "Learning Lab",
					Allposts: "All posts",
					Mypicks: "My picks",
					By: "By",
					Created: "Created",
					Lastreply: "Last reply",
					like: "Like",
					favorite: "Favorite",
					reward: "reward",
					previous: "Previous",
					next: "Next",
					Comment: "Comment",
					retract: "retract",
					more: "more",
					AllComment: "All Comment",
					Reward: "Reward",
					CurrentPoints: "Current Points",
					Ifyou: "If you like this post, you can reward the author with points",
					Title: "Title",
					pleasetitle: "please enter title",
					postto: "post to",
					pleaseselect: "please select",
					selectgroup: "click to select group",
					setreward: "set reward points",
					setup: "set up",
					currentpoints: "current points",
					content: "content",
					attachment: "attachment",
					add: "add",
					Supportedfile: "Supported file",
					draftbox: "draft box",
					//管理员
					shanchupinlun:'Delete',
					yincanpinlun:'Hide',
					zhidingpinlun:'Top'

				},
				resource: {
					sousuo1: 'Search keywords',
					sousuo2: 'Explore GoodWe Community Learning Lab right now !',
					videoPlaylists: 'Playlists',
					videofullplaylist: 'View full playlist',
					videoLanguage: 'Language',
					videoCountry: 'Country',
					videoProduct: 'Product',
					videoType: 'Type',
					videoRelatedProducts: 'Related Products',
					videoPopularSolutions: "Popular Solutions",
					videoTrendingVideos: "Trending Videos",
					videoAllvideo: "All video",
					videoPlaylistdetail: "Playlist-detail",
					Search:'Search',
				},
				activity: {
					toptitle:'Become a GoodWe ESA ',
					toptitlex:'Master Service Partner ',
					toptitle2:'Get certified to commission and maintain GoodWe ESA C&I energy storage systems (125kW / 261kWh) ',
					toptitle3:'The GoodWe ESA Master Service Partner Certification validates your expertise in commissioning, maintaining, and repairing GoodWe’s commercial and industrial energy storage systems. Certified partners are recognized as trusted service providers capable of delivering the highest standard of technical service.',
					topbtn:'Start Your Certification ',
					topbtn2:'*Active GoodWe PLUS+ membership required ',
					Whattoptitle:'WHAT IS THE MASTER SERVICE PARTNER',
					Whattoptitle2:'CERTIFICATION?',
					Validatetitle:'Validate Your Expertise',
					Validateneirong:'Demonstrate that your team has mastered GoodWe ESA commissioning, maintenance, and safety protocols through rigorous theory and practical evaluation.',
					Validatetitle2:'Advance Your Business',
					Validateneirong2:'Distinguish your company as a certified service partner. Customers trust Master Service Partners to deliver professional, safe, and reliable ESA system support.',
					Validatetitle3:'Unlock Rewards',
					Validateneirong3:'Earn GoodWe PLUS+ points for certified commissioning and maintenance activities. Redeem points for awards, training, and other benefits.',
					CERTIFICATIONtop:'CERTIFICATION JOURNEY',
					CERTItitle:'Pre-requisite',
					CERTIneirong:'Join GoodWe PLUS+ and complete the required ESA training program',
					CERTItitle2:'Theory Exam',
					CERTIneirong2:'Take the online exam via the GoodWe PLUS+ community (80% pass mark required)',
					CERTItitle3:'Practical Evaluation',
					CERTIneirong3:'Demonstrate your skills during an actual ESA commissioning under GoodWe expert supervision',
					CERTItitle4:'Get Certified',
					CERTIneirong4x:'Receive your certificate (valid for 1 year) and start performing certified work',
					CERTItitle5:'*During the exam, the candidate will need to provide the following information: full name of the candidate, ',
					CERTItitle6:'company name, SEMS organisation code of the company, and SEMS email address of the company.',
					SERVICEtitle:'WHAT YOU CAN DO AS A MASTER',
					SERVICEtitlexx:'SERVICE PARTNER',
					SERVICEtitle2:'Once certified, your company is authorized to perform:',
					SERVICEtitlex:'First commissioning of GoodWe ESA systems',
					SERVICEtitlex2:'Routine and corrective maintenance',
					SERVICEtitlex3:'Component replacement (including batteries, PCS, distribution box components, cooling units, and fire protection components)',
					SERVICEtitlex4:'Firmware updates via USB or IoT',
					SERVICEtitlex5:'System acceptance and sign-off on behalf of GoodWe',
					SERVICEtitlex6:'Note: All work must be performed in accordance with the GoodWe ESA Master Service Partner Standard Operating Procedure (SOP).',
					Questionstoptitle:'Frequently Asked Questions',
					Questionsquestions:' What are the prerequisites for the certification? ',
					Questionshuida:'You must join GoodWe PLUS+ and complete the required ESA training program before you can take the certification exam. ',
					Questionsquestions1:' How long is the certification valid? ',
					Questionshuida1:'The Master Service Partner certification is valid for 1 year from the date of issuance. ',
					Questionsquestions2:' What does the practical evaluation involve? ',
					Questionshuida2:'The practical evaluation requires demonstrating your skills during an actual ESA commissioning under GoodWe expert supervision. ',
					Questionsquestions3:' How do I earn rewards as a certified partner? ',
					Questionshuida3:'You earn GoodWe PLUS+ points for certified commissioning and maintenance activities, which can be redeemed for awards and training. ',
					Questionsquestions4:' What systems can I work on after certification? ',
					Questionshuida4:'As a certified partner, you can perform first commissioning, routine maintenance, and component replacement on GoodWe ESA systems. ',
					Questionsquestions5:' Is there ongoing support for certified partners? ',
					Questionshuida5:'Yes, certified partners have access to the GoodWe PLUS+ community and ongoing technical support resources. ',
					Questionsquestions6:' How often do I need to recertify? ',
					Questionshuida6:'Certification must be renewed annually to maintain your Master Service Partner status. ',
					
					Certifiedtitle:'Ready to Get Certified?',
					Certifiedtitle2:'Start your journey today. Take the first step by logging into the GoodWe PLUS+ community and ',
					Certifiedtitle2x:'accessing the certification exam.',
					Certifiedtitle3:'Start Your Certificatio',
					Certifiedtitle4:'Questions? Contact the GoodWe Service Team: service@goodwe.com'
				},
				plus: {
					JoinGOODWE: "Join GOODWE PLUS+",
					NotaMember: "Not a Member? Join Us",
					Alreadya: "Already a Member? Login",
					MasterServicePartner: "Master Service Partner",
					NOTAMEMBERYET: "NOT A MEMBER YET? GET QUALIFIED.",
					PREPARE: "PREPARE",
					LoginwithSEMS: "Login with SEMS+ Account",
					NewtoSEMS: "New to SEMS+? ",
					Register: 'Register',
					nowandjoin:" now and join us!",
					
					Loginnow: "Login now",
					UseaSEMS: "Use a SEMS+ Installer Organization representative account",
					Qualify: "Qualify",
					PasstheExam: "Pass the Exam to Unlock Membership",
					LearnFirst: "Learn First: Explore the ",
					LearnFirst2: "GoodWe PLUS+ Exam Preparation Playlist",
					StartExam: "Start Exam",
					OnlySEMS: "Only SEMS+ Installers Are Eligible for This Program",
					QualifyFor: "Qualify For Membership Today",
					BySuccessfully: "By Successfully Passing the Exam",
					WHYBECOME: "WHY BECOME A GOODWE PLUS+",
					INSTALLERCOMPANY: "INSTALLER COMPANY?",
					AGlobalProgram: "A Global Program for Exclusive Installer Benefits",
					QUALIFY: "QUALIFY",
					Passthecert: "Pass the certification exam",
					INSTALL: "INSTALL",
					InstallGoodWe: "Install GoodWe product",
					EARN: "EARN",
					Earnpoints: "Earn points automatically for every installation",
					UPGRADE: "UPGRADE&REDEEM",
					Upgradeyour: "Upgrade your membership and unlock exclusive member benefits",
					Preparefor: "PREPARE FOR YOUR EXAM",
					withLearning: "WITH LEARNING RESOURCES",
					Allexamcontent: "All exam content is from the GoodWe PLUS+ Exam Preparation Playlist. Please visit the video playlist to select courses for your region and language.",
					LearnMore: "Learn More",
					GWPlus: "GW Plus+ FAQ ", // 没有
					Goodmorning: "Good morning",
					Hello: "Hello: ",
					Yourcurrent: "Your current status is:",
					Youneed: ". You need ",
					pointstoachieve: "points to achieve the next level. Your current status will be expired: ",
					Currentstatus: "Current status",
					SEMSOrganization: "SEMS+ Organization Code", // 没有
					Email: "Email",
					Validuntil: "Valid until end of ",
					pointsearned: "points earned",
					Updatedatthe: "Updated at the start of each month",
					Clickonthe: "Click on the top to enter the points details",
					putong: ['Upgrade to SILVER tier by earning ',
						'points by the end of the year. Upgrade to GOLD tier by earning a total of',
						' points by the end of the year.'
					],
					yinpai: ['Upgrade to GOLD tier by earning a total of ',
						'points by the end of the year. Retain SILVER tier by earning a total of',
						' points by the end of the year.'
					],
					jinpai: ['Achieve SILVER tier by earning a total of ',
						'points by the end of the year. Retain to GOLD tier by earning a total of',
						' points by the end of the year.'
					],
					Promotionalmaterials: "Promotional materials",
					Certificate: "Certificate",
					Howtoearn: "How to earn points",
					RedeemyourGood: "Redeem your GoodWe PLUS+ points",
					points: "points",
					Alreadyredeemed: "Already redeemed",
					Clickonthe: "Click on the circle to enter the points details",
					Totalredeemable: "Total redeemable points collected during validity period:",
					InstallationRecord: "Installation Record",
					DATE: "DATE",
					MODELTYPE: "MODEL TYPE",
					CAPACITY: "CAPACITY",
					NUMBER: "NUMBER",
					POINTS: "POINTS",
				},
				Promotion:{
					title:'HOW TO PARTICIPATE?',
					title1:"JOIN GOODWE PLUS+",
					title2:"UPLOAD DOCUMENTS",
					title3:'RECEIVE REBATE',
					joinstep:'STEP',
					joinneirong1:'Visit our website',
					joinneirong12:' [GoodWe PLUS+ Program] ',
					joinneirong13:'and follow the instructions to become a GoodWe PLUS+ member.',
					joinneirong2:'After completing the installation of Lynx U G3 batteries, upload the purchase invoices, installation reports, and other required documents to our designated platform.',
					joinn2from:{
						Name:'Name',
						City:'City',
						Country:'Country',
						Zip:'Zip',
						CompanyName:'Company Name',
						StreetHousenumber:'Street and Housenumber',
						Email:'Email',
						Phone:'Phone',
						IBAN:'IBAN',
						BIC:'BIC',
						purchaseddevices:'Serial no. of new purchased devices',
						recogniseddevices:'Serial no. of recognised devices',
						Purchaseorder:'Purchase order',
						Amount:'Amount',
						Submit:'Submit'
					},
					// joinneirong3:'Once the documents are verified, the 140 - euro rebate per battery will be credited to your account within [30] business days.',
					joinneirong3:'Once the documents are verified, the €140 rebate per battery will be credited to your account within six weeks, and the warranty for each Lynx U G3 battery installed under this promotion will also be extended by one year within the same period.',
					join4biaoti:'Membership Requirement',
					join4biaoti1:'Rebate Mechanism',
					join4neirong:'Once joined, installers can upload necessary purchase orders and installation records. Meanwhile, the installer will receive an email as proof of participation. After verification, we will provide a rebate of 140 euros for each Lynx U G3 battery installed. This rebate not only helps to offset the cost of the additional batteries but also rewards our partners for their continued support and excellent service.',
					join4biaoti2:'Benefits of Lynx U G3',
					LearnMore :'Learn More '
				},
				Personal: {
					Address: 'Address',
					zuolies:["Profile", "Notification", "Posts", "Webinar", "My points"],
					Submit: 'Enviar',
					Posts: 'Posts',
					MyPicks: 'My Picks',
					profile: 'profile',
					Personalinformation: 'Personal information',
					UserName: 'User Name',
					Country: 'Country/Region',
					language: 'language',
					// Region:'Region',
					Email: 'Email',
					Organization: 'Organization',
					JobTitle: 'JobTitle',
					semscode: 'semscode',
					registered: 'Registered',
					date: 'date',
					action: 'action',
					points: 'Points',
					InstallEquipment: 'Install Equipment',
					EarnedfromForum: 'Earned from Forum',
					UsedforReward: 'Used for Reward',
					UsedforRedemption: 'Used for Redemption',
					PointsExpired: 'Points Expired',
				},
				PointsMall: {
					mypoints: 'My points:',
					Entity: 'Entity',
					Extendedwarranty: 'Extended warranty',
					Inventoryshortage: 'Inventory shortage',
					shippingaddress: 'Please select your shipping address',
					Shippinginformation: 'Shipping information',
					DAddress: 'Default Address',
					Modify: 'Modify',
					Addreceivingaddress: 'Add receiving address',
					Addnewaddress: 'Add new address',
					CountryRegion: 'Country/Region:',
					DetailedAddress: 'Detailed Address:',
					Receiver: 'Receiver :',
					Tel: 'Tel:',
					Email: 'Email:',
					Setasdefaultaddress: 'Set as default address',
					Cancel: 'Cancel',
					Edit: 'Edit' [{}],
					Delete: 'Delete',
					Warrantyextensionpurchase: 'Warranty extension purchase',
					DEVICESERIALNUMBER: 'DEVICE SERIAL NUMBER',
					LIMITEDWARRANTY: 'LIMITED WARRANTY',
					Warrantyextensionoption: 'Warranty extension option',
					Pleaseextension: 'Please click here to choose suitable warranty extension year.',
					Pricepoint: 'Price(point)',
					Youraccount: 'Your account',
					Redeem: 'Redeem'
				},
				Exam: {
					ExamDetails: 'Exam Details',
					Cancel: 'CANCEL',
					QuestionType: 'Question Type：',
					QuestionType2: 'Multiple-choice and true/false questions.',
					FullScore: 'Full Score',
					FullScore2: ' 100 points',
					PassingScore: 'Passing Score',
					PassingScore2: ' 80 points or above',
					Attempts: 'Attempts',
					Attempts2: 'Unlimited attempts allowed',
					Interruption: 'Interruption',
					Interruption2: 'If you exit midway, you will need to restart the exam',
					gotit: 'I got it',
					exambiaoti: 'GoodWe PLUS+ Membership Exam System',
					exambiaoti1: 'Pass the exam to become a GoodWe PLUS+ member and unlock more exclusive membership benefits!',
					exambiaoti3: 'Start Exam',
					exambiaoti4: "Not Ready? Study more",
					exam2Next: 'Next',
					exam2Submit: 'Submit',
					exam2Congratulations: 'Congratulations!',
					exam2PLUS: 'You are now a GoodWe PLUS+ Member!',
					exam2Thankyou: 'Thank you for participating! Now you can explore exclusive member benefits and unlock more exciting content.',
					exam2GotoMember: 'Go to Member-Exclusive Page',
					exam2Benefits: 'Explore More Benefits',
					exam2pass: 'You did not pass.',
					exam2quiz: 'Sorry, you did not pass the quiz',
					exam2Finish: 'Finish',
					exam2Try: 'Try Again'
				},
				Logins:{
					LogInWithYourAccount:'Log In With Your Account',
					Donthaveanaccountyet:'Don`t have an account yet?',
					SignupasEndUser:'Sign up SEMS',
					SignupasInstaller:'Sign up as Installer'
				},
				tuijian:{
					pone1_1:'CALCULATOR',
					pone1_2:'Achieve your energy independence',
					pone1_3:'Start',
					pone2_1:'Grid Voltage',
					pone2_2:'In this step, you will choose the hybrid inverter model',
					pone2_3:'Confirm',
					pone2_4:'Having trouble?',
					pone2_5:'Feel free to contact us and we will always help you through the process.',
					pone2_6:'Contact us',
					pone3_1:'Load Table',
					pone3_2:'Select the desired equipment from the options in the catalog and specify the quantity, or enter it manually if necessary.',
					pone3_3:'Autonomy',
					pone3_4:'Power',
					pone3_5:'Watts',
					pone3_6:'Add',
					pone3_7:'TOTAL',
					pone3_8:'Total Power',
					pone3_9:'Total Consumption',
					pone3_10:'Confirm',
					pone4_1:'Results',
					pone4_2:'Next, you will see some recommendations for Inverters and the  chosen Battery.',
					pone4_3:'Recommended Inverter',
					pone4_2:'Next, you will see some recommendations for Inverters and the  chosen Battery.',
					pone4_6:'Product detail',
					pone4_4:'Quantity',
					pone4_5:'Battery',
					pone4_7:'Print'
				}
			},
			PT: {
				shouye: {
					toubu: {
						loginsems: 'Entrar com (SEMS+)',
						dhforum: "Fórum",
						dhPointsMall: "Loja de Pontos",
						list: [{
							name: 'Fórum',
							url: 'forum'
						}, {
							name: 'Laboratório de Aprendizagem',
							url: 'LearningLab'
						}, {
							name: 'GoodWe PLUS+',
							url: 'plus'
						}, {
							name: 'Loja de Pontos',
							url: 'pointsMall'
						}],
						list4: [{
							name: 'Fórum',
							url: 'forum'
						}, {
							name: 'Laboratório de Aprendizagem',
							url: 'LearningLab'
						}, {
							name: 'GoodWe PLUS+',
							url: 'plus'
						}, {
							name: 'Loja de Pontos',
							url: 'pointsMall'
						},{
							name: 'Ambassador',
							url: 'Ambassador'
						}],
						list2: [{
								name: 'Fórum',
								url: '/forum'
							},
							{
								name: 'Laboratório de Aprendizagem',
								url: '/LearningLab',
								menulist: [{
									name: 'Video',
									url: '/video'
								}, {
									name: 'Blog',
									url: '/blog'
								}, {
									name: 'Webinar',
									url: '/webinar'
								}
								// , {
								// 	name: 'Calculator',
								// 	url: ''
								// },
								],
							},
							{
								name: 'GoodWe PLUS+',
								url: '/plus'
							}, {
								name: 'Loja de Pontos',
								url: '/pointsMall'
							}
						],
						
					},
					contant: {
						Resource: "Laboratório de Aprendizagem",
						PopularPost: "Posts populares",
						More: "Mais",
						PopularGroup: "Grupos populares",
						findoutmore: "Saiba mais",
						postedin: "postado em",
						plusbt1: "JUNTE-SE AO GOODWE PLUS+ AGORA!",
						plusbt11: "Benefícios do Program",
						plusbt112: "A associação GoodWe PLUS+ vem com benefícios atrativos",
						plusbt113: "Explorar mais",
						plusbt12: "Critérios de Qualificação",
						plusbt122: "Passo a passo para se qualificar como GoodWe PLUS+",
						plusbt123: "Começar agora",
						plusbt13: "Perguntas Frequentes",
						plusbt132: "Nossa seção de FAQ contém mais detalhes sobre o processo de qualificação",
						plusbt133: "Ver mais",
						plusbt2: "SOBRE A GOODWE SOLAR ACADEMY",
						plusbt21: "Nosso objetivo é fornecer suporte de pré-venda além das expectativas e construir uma plataforma aberta para compartilhamento de conhecimento e treinamento técnico na indústria fotovoltaica global.",
						stayin: "FIQUE POR DENTRO!",
						stayin2: "Inscreva-se na nossa newsletter. Não faremos spam. Apenas uma atualização por mês.",
						stayin3: "por favor, insira um endereço de e-mail",
						stayin4: "enviar"
					}
				},
				
				xinzengde:{
					Username:'Nome de Usuário',
					OrganizationNa:'Organizacao',
					SEMSCode:'Código SEMS+',
					LastReply:'Ultima resposta',
					ViewAnswers:'Ver Respostas',
					ExamResults:'Resultados da Prova',
					Back:'Voltar'
				},
				tuijian:{
					pone1_1:'CALCULADORA',
					pone1_2:'Alcance sua independência energética',
					pone1_3:'Iniciar',
					pone2_1:'Tensão da Rede',
					pone2_2:'Nesta etapa, você escolherá o modelo do inversor híbrido.',
					pone2_3:'Confirmar',
					pone2_4:'Enfrentando dificuldades?',
					pone2_5:'Entre em contato conosco e lhe ajudaremos.',
					pone2_6:'Contate-nos',
					pone3_1:'Tabela de Carga',
					pone3_2:'Selecione o equipamento desejado nas opções do catálogo e especifique a quantidade, ou insira manualmente se necessário.',
					pone3_3:'Autonomia ',
					pone3_4:'Potência',
					pone3_5:'Watts',
					pone3_6:'Adicionar',
					pone3_7:'TOTAL',
					pone3_8:'Potência Total',
					pone3_9:'Consumo Total',
					pone3_10:'Confirmar',
					pone4_1:'Resultados',
					pone4_2:'A seguir, você verá algumas recomendações de Inversores e  Baterias.',
					pone4_3:'Inversor Recomendado',
					pone4_6:'Detalhe do Produto',
					pone4_4:'Quantidade',
					pone4_5:'Bateria',
					pone4_7:'Print'
				},
				forum: {
					Search:"Busca",
					Post:"Post",
					AllGroups: "Todos os Grupos",
					GettingStarted: "Primeiros Passos",
					Official: "Postagens Oficiais",
					Resource: "Laboratório de Aprendizagem",
					Allposts: "Todas as postagens",
					Mypicks: "Minhas escolhas",
					By: "Por",
					Created: "Criado",
					Lastreply: "Última resposta",
					like: "Curtir",
					favorite: "Favorito",
					reward: "recompensa",
					previous: "Anterior",
					next: "Próximo",
					Comment: "Comentário",
					retract: "recolher",
					more: "mais",
					AllComment: "Todos os Comentários",
					Reward: "Recompensa",
					CurrentPoints: "Pontos Atuais",
					Ifyou: "Se curtiu esse post, você pode recompensar o autor com pontos",
					Title: "Título",
					pleasetitle: "insira o título",
					postto: "publicar em",
					pleaseselect: "por favor selecione",
					selectgroup: "clique para selecionar grupo",
					setreward: "definir pontos de recompensa",
					setup: "configurar",
					currentpoints: "pontos atuais",
					content: "conteúdo",
					attachment: "anexo",
					add: "adicionar",
					Supportedfile: "arquivo suportado",
					draftbox: "caixa de rascunhos",
					shanchupinlun:'Delete',
					yincanpinlun:'Hide',
					zhidingpinlun:'Top'
					
				},
				resource: {
					sousuo1: 'Pesquisar palavras-chave',
					sousuo2: 'Explore os Recursos da Comunidade GoodWe agora mesmo!',
					videoPlaylists: 'Playlists',
					videofullplaylist: 'Ver playlist completa',
					videoLanguage: 'Idioma',
					videoCountry: 'País',
					videoProduct: 'Produto',
					videoType: 'Tipo',
					videoRelatedProducts: 'Produtos Relacionados',
					videoPopularSolutions: "Soluções Populares",
					videoTrendingVideos: "Vídeos em Alta",
					videoAllvideo: "Todos os vídeos",
					videoPlaylistdetail: "Detalhes da Playlist",
					Search:'Procurar',
				},
				activity: {
					toptitle:'Become a GoodWe ESA ',
					toptitlex:'Master Service Partner ',
					toptitle2:'Get certified to commission and maintain GoodWe ESA C&I energy storage systems (125kW / 261kWh) ',
					toptitle3:'The GoodWe ESA Master Service Partner Certification validates your expertise in commissioning, maintaining, and repairing GoodWe’s commercial and industrial energy storage systems. Certified partners are recognized as trusted service providers capable of delivering the highest standard of technical service.',
					topbtn:'Start Your Certification ',
					topbtn2:'*Active GoodWe PLUS+ membership required ',
					Whattoptitle:'WHAT IS THE MASTER SERVICE PARTNER',
					Whattoptitle2:'CERTIFICATION?',
					Validatetitle:'Validate Your Expertise',
					Validateneirong:'Demonstrate that your team has mastered GoodWe ESA commissioning, maintenance, and safety protocols through rigorous theory and practical evaluation.',
					Validatetitle2:'Advance Your Business',
					Validateneirong2:'Distinguish your company as a certified service partner. Customers trust Master Service Partners to deliver professional, safe, and reliable ESA system support.',
					Validatetitle3:'Unlock Rewards',
					Validateneirong3:'Earn GoodWe PLUS+ points for certified commissioning and maintenance activities. Redeem points for awards, training, and other benefits.',
					CERTIFICATIONtop:'CERTIFICATION JOURNEY',
					CERTItitle:'Pre-requisite',
					CERTIneirong:'Join GoodWe PLUS+ and complete the required ESA training program',
					CERTItitle2:'Theory Exam',
					CERTIneirong2:'Take the online exam via the GoodWe PLUS+ community (80% pass mark required)',
					CERTItitle3:'Practical Evaluation',
					CERTIneirong3:'Demonstrate your skills during an actual ESA commissioning under GoodWe expert supervision',
					CERTItitle4:'Get Certified',
					CERTIneirong4x:'Receive your certificate (valid for 1 year) and start performing certified work',
					CERTItitle5:'*During the exam, the candidate will need to provide the following information: full name of the candidate,',
					CERTItitle6:'company name, SEMS organisation code of the company, and SEMS email address of the company.',
					SERVICEtitle:'WHAT YOU CAN DO AS A MASTER',
					SERVICEtitlexx:'SERVICE PARTNER',
					SERVICEtitle2:'Once certified, your company is authorized to perform:',
					SERVICEtitlex:'First commissioning of GoodWe ESA systems',
					SERVICEtitlex2:'Routine and corrective maintenance',
					SERVICEtitlex3:'Component replacement (including batteries, PCS, distribution box components, cooling units, and fire protection components)',
					SERVICEtitlex4:'Firmware updates via USB or IoT',
					SERVICEtitlex5:'System acceptance and sign-off on behalf of GoodWe',
					SERVICEtitlex6:'Note: All work must be performed in accordance with the GoodWe ESA Master Service Partner Standard Operating Procedure (SOP).',
					Questionstoptitle:'Frequently Asked Questions',
					Questionsquestions:' What are the prerequisites for the certification? ',
					Questionshuida:'You must join GoodWe PLUS+ and complete the required ESA training program before you can take the certification exam. ',
					Questionsquestions1:' How long is the certification valid? ',
					Questionshuida1:'The Master Service Partner certification is valid for 1 year from the date of issuance. ',
					Questionsquestions2:' What does the practical evaluation involve? ',
					Questionshuida2:'The practical evaluation requires demonstrating your skills during an actual ESA commissioning under GoodWe expert supervision. ',
					Questionsquestions3:' How do I earn rewards as a certified partner? ',
					Questionshuida3:'You earn GoodWe PLUS+ points for certified commissioning and maintenance activities, which can be redeemed for awards and training. ',
					Questionsquestions4:' What systems can I work on after certification? ',
					Questionshuida4:'As a certified partner, you can perform first commissioning, routine maintenance, and component replacement on GoodWe ESA systems. ',
					Questionsquestions5:' Is there ongoing support for certified partners? ',
					Questionshuida5:'Yes, certified partners have access to the GoodWe PLUS+ community and ongoing technical support resources. ',
					Questionsquestions6:' How often do I need to recertify? ',
					Questionshuida6:'Certification must be renewed annually to maintain your Master Service Partner status. ',
					
					Certifiedtitle:'Ready to Get Certified?',
					Certifiedtitle2:'Start your journey today. Take the first step by logging into the GoodWe PLUS+ community and ',
					Certifiedtitle2x:'accessing the certification exam.',
					Certifiedtitle3:'Start Your Certificatio',
					Certifiedtitle4:'Questions? Contact the GoodWe Service Team: service@goodwe.com'
				},
				plus: {
					JoinGOODWE: "JUNTE-SE AO GOODWE PLUS+",
					NotaMember: "Ainda não é membro? Junte-se a nós",
					Alreadya: "Já é Membro? Faça login",
					MasterServicePartner: "Master Service Partner",
					NOTAMEMBERYET: "AINDA NÃO É MEMBRO? QUALIFIQUE-SE.",
					PREPARE: "PREPARO",
					LoginwithSEMS: "Entre com uma conta SEMS+",
					NewtoSEMS: "Novo no SEMS+? ",
					Register: 'Registre-se',
					nowandjoin:" agora e junte-se a nós!",
					Loginnow: "Entrar agora",
					UseaSEMS: "Use uma conta Corporativa de Integrador SEMS+",
					Qualify: "Qualificação",
					PasstheExam: "Passe na Prova para desbloquear a associação",
					LearnFirst: "Estude Primeiro: Explore ",
					LearnFirst2: "a Playlist de Preparação para a Prova GoodWe PLUS+",
					StartExam: "Começar Prova",
					OnlySEMS: "Apenas Contas Corporativas SEMS+ são elegíveis para este programa",

					QualifyFor: "Qualifique-se para ser Membro Hoje",
					BySuccessfully: "Ao passar com sucesso na Prova",
					WHYBECOME: "POR QUE SE TORNAR UMA EMPRESA",
					INSTALLERCOMPANY: "INSTALADORA GOODWE PLUS+?",
					AGlobalProgram: "Um programa global com benefícios exclusivos para instaladores",
					QUALIFY: "QUALIFICAR",
					Passthecert: "Passe na prova de certificação",
					INSTALL: "INSTALAR",
					InstallGoodWe: "Instale produtos GoodWe",
					EARN: "GANHAR",
					Earnpoints: "Ganhe pontos automaticamente por cada inversor instalado",

					UPGRADE: "ATUALIZAR & RESGATAR",
					Upgradeyour: "Atualize sua associação e desbloqueie benefícios exclusivos",
					Preparefor: "PREPARE-SE PARA A PROVA",
					withLearning: "COM RECURSOS DE APRENDIZAGEM",
					Allexamcontent: "Todo o conteúdo da prova está na Playlist de Preparação da Prova GoodWe PLUS+. Visite a playlist de vídeos para selecionar cursos por região e idioma.",
					LearnMore: "Saiba mais",
					GWPlus: "FAQ do GW Plus+",
					Goodmorning: "Bom dia",
					Hello: "Olá: ",
					Yourcurrent: "Seu status atual é:",
					Youneed: ". Você precisa de ",
					pointstoachieve: "pontos para atingir o próximo nível. Seu status atual expirará em: ",
					Currentstatus: "Status atual",
					SEMSOrganization: "Código de Conta Corporativa SEMS+",
					Email: "E-mail",
					Validuntil: "Válido até final de ",
					pointsearned: "pontos acumulados",
					Updatedatthe: "Atualizado no início de cada mês",
					Clickonthe: "Clique no topo para ver os detalhes dos pontos",
					putong: ['Atualize para nível SILVER acumulando ',
						'pontos até o final do ano. Atualize para nível GOLD acumulando',
						' pontos até o final do ano.'
					],
					yinpai: ['Atualize para GOLD com ', 'pontos até o fim do ano. Mantenha SILVER com',
						' pontos até o fim do ano.'
					],
					jinpai: ['Garanta SILVER com ', 'pontos até o fim do ano. Mantenha GOLD com ',
						' pontos até o fim do ano.'
					],

					Promotionalmaterials: "Materiais Promocionais",
					Certificate: "Certificado",
					Howtoearn: "Como ganhar pontos",
					RedeemyourGood: "Resgatar seus pontos GoodWe PLUS+",
					points: "pontos",
					
					Alreadyredeemed: "Já resgatado",
					Clickonthe: "Clique no círculo para ver os detalhes dos pontos",
					Totalredeemable: "Total de pontos resgatáveis acumulados durante o período de validade:",
					InstallationRecord: "Registro de Instalação",
					DATE: "DATA",
					MODELTYPE: "MODELO",
					CAPACITY: "CAPACIDADE",
					NUMBER: "NÚMERO",
					POINTS: "PONTOS",
				},
				Promotion:{
					title:'HOW TO PARTICIPATE?',
					title1:"JOIN GOODWE PLUS+",
					title2:"UPLOAD DOCUMENTS",
					title3:'RECEIVE REBATE',
					joinstep:'STEP',
					joinneirong1:'Visit our official website',
					joinneirong12:' [GoodWe PLUS+ Programm] ',
					joinneirong13:'and follow the instructions to become a GoodWe PLUS+ member.',
					joinneirong2:'After completing the installation of Lynx U G3 batteries, upload the purchase invoices, installation reports, and other required documents to our designated platform.',
					joinn2from:{
						Name:'Name',
						City:'City',
						Country:'Country',
						Zip:'Zip',
						CompanyName:'Company Name',
						StreetHousenumber:'Street and Housenumber',
						Email:'Email',
						Phone:'Phone',
						IBAN:'IBAN',
						BIC:'BIC',
						purchaseddevices:'Serial no. of new purchased devices',
						recogniseddevices:'Serial no. of recognised devices',
						Purchaseorder:'Purchase order',
						Amount:'Amount',
						Submit:'Submit'
					},
					joinneirong3:'Once the documents are verified, the €140 rebate per battery will be credited to your account within six weeks, and the warranty for each Lynx U G3 battery installed under this promotion will also be extended by one year within the same period.',
					join4biaoti:'Membership Requirement',
					join4biaoti1:'Rebate Mechanism',
					join4neirong:'Once joined, installers can upload necessary purchase orders and installation records. Meanwhile, the installer will receive an email as proof of participation. After verification, we will provide a rebate of 140 euros for each Lynx U G3 battery installed. This rebate not only helps to offset the cost of the additional batteries but also rewards our partners for their continued support and excellent service.',
					join4biaoti2:'Benefits of Lynx U G3',
				},
				Personal: {
					Address: 'endereço',
					zuolies:["Perfil", "Notification", "Postagens", "Webinar", "Meus pontos:"],
					Submit: 'Submit',
					Posts: 'Postagens',
					MyPicks: 'Minhas Escolhas',
					profile: 'Perfil',
					Personalinformation: 'Informações Pessoais',
					UserName: 'Nome de Usuário ',
					// Country:'País',
					// Region:'Região',
					language: 'Idioma',
					CountryRegion: 'País / Região:',
					Email: 'E-mail',
					Organization: 'Organização',
					JobTitle: 'Cargo',
					semscode: 'Código SEMS+',
					registered: 'registrado',
					date: 'data',
					action: 'ação',
					points: 'pontos',
					InstallEquipment: 'Instalar Equipamento',
					EarnedfromForum: 'Ganhos no Fórum',
					UsedforReward: 'Usado como Recompensa',
					UsedforRedemption: 'Usado para Resgate',
					PointsExpired: 'Pontos Expirados'
				},
				PointsMall: {
					mypoints: 'meus pontos:',
					Entity: 'Entidade',
					Extendedwarranty: 'Garantia Estendida',
					Inventoryshortage: 'Falta de Estoque',
					shippingaddress: 'Por favor, selecione seu endereço de envio',
					Shippinginformation: 'Informações de envio',
					DAddress: 'Endereço padrão',
					Modify: 'Modificar',
					Addreceivingaddress: 'Adicionar endereço de recebimento',
					Addnewaddress: 'Adicionar Novo endereço',
					CountryRegion: 'País / Região:',
					DetailedAddress: 'Endereço detalhado:',
					Receiver: 'Destinatário:',
					Tel: 'Telefone:',
					Email: 'E-mail:',
					Setasdefaultaddress: 'Definir como endereço padrão',
					Cancel: 'Cancelar',
					Edit: 'Editar',
					Delete: 'Excluir',
					Warrantyextensionpurchase: 'Compra de extensão de garantia',
					DEVICESERIALNUMBER: 'NÚMERO DE SÉRIE DO DISPOSITIVO',
					LIMITEDWARRANTY: 'GARANTIA LIMITADA',
					Warrantyextensionoption: 'Opção de extensão de garantia',
					Pleaseextension: 'Clique aqui para escolher o período adequado de extensão de garantia',
					Pricepoint: 'Preço (em pontos)',
					Youraccount: 'Sua conta',
					Redeem: 'Resgatar'
				},
				Exam: {
					ExamDetails: 'Detalhes da Prova',
					Cancel: 'CANCELAR',
					QuestionType: 'Tipo de Questão:',
					QuestionType2: 'Múltipla escolha e verdadeiro/falso. ',
					FullScore: 'Pontuação Máxima: ',
					FullScore2: '100 pontos',
					PassingScore: 'Nota de Aprovação: ',
					PassingScore2: '80 pontos ou mais ',
					Attempts: 'Tentativas: ',
					Attempts2: 'Tentativas ilimitadas permitidas. ',
					Interruption: 'Interrupção:',
					Interruption2: ' Se você sair no meio, terá que reiniciar a prova"',
					gotit: 'Eu entendi',
					exambiaoti: 'Sistema de Prova da Associação GoodWe PLUS+',
					exambiaoti1: 'Passe na prova para se tornar membro GoodWe PLUS+ e desbloquear benefícios exclusivos!',
					exambiaoti3: 'Iniciar Prova',
					exambiaoti4: 'Não está pronto? Estude mais',
					exam2Next: 'Próximo',
					exam2Submit: 'Enviar',
					exam2Congratulations: 'Parabéns! ',
					exam2PLUS: 'Agora você é um membro GoodWe PLUS+!',
					exam2Thankyou: 'Obrigado por participar! Agora você pode explorar benefícios exclusivos e desbloquear mais conteúdos.',
					exam2GotoMember: 'Ir para Página Exclusiva de Membros',
					exam2Benefits: 'Explorar Mais Benefícios',
					exam2pass: 'Você não passou.',
					exam2quiz: 'Desculpe, você não passou no teste',
					exam2Finish: 'Finalizar',
					exam2Try: 'Tentar Novamente'
				},
				Logins:{
					LogInWithYourAccount:'Entrar com sua conta',
					Donthaveanaccountyet:'Ainda não tem uma conta?',
					SignupasEndUser:'Cadastre-se como Usuário Final',
					SignupasInstaller:'Cadastre-se como Instalador'
				}
			},
			PK: {
				shouye: {
					toubu: {
						loginsems: "log in with (SEMS+)",
						// dhforum:"Forum",
						// dhPointsMall:"Points Mall",
						list: [{
							name: 'Forum',
							url: ''
						}, {
							name: 'Learning Lab',
							url: 'LearningLab'
						}, {
							name: 'GoodWe PLUS+',
							url: 'plus'
						}, {
							name: 'Points Mall',
							url: 'pointsMall'
						}],
						list4: [{
							name: 'Forum',
							url: ''
						}, {
							name: 'Learning Lab',
							url: 'LearningLab'
						}, {
							name: 'GoodWe PLUS+',
							url: 'plus'
						}, {
							name: 'Points Mall',
							url: 'pointsMall'
						},{
							name: 'Ambassador',
							url: 'Ambassador'
						}],
						
						list2: [{
								name: 'Forum',
								url: ''
							},
							{
								name: 'Learning Lab',
								url: '/LearningLab',
								menulist: [{
									name: 'Video',
									url: '/video'
								}, {
									name: 'Blog',
									url: '/blog'
								}, {
									name: 'Webinar',
									url: '/webinar'
								}
								// , {
								// 	name: 'Calculator',
								// 	url: ''
								// }
								],
							},
							{
								name: 'GoodWe PLUS+',
								url: '/plus'
							}, {
								name: 'Points Mall', 
								url: '/pointsMall'
							}
						],
					},
					contant: {
						Resource: "Learning Lab",
						PopularPost: "Popular Post",
						More: "More",
						PopularGroup: "Popular Group",
						findoutmore: "Find out more",
						postedin: "posted in",
						plusbt1: "JOIN GOODWE PLUS+ NOW!",
						plusbt11: "Program Benefits",
						plusbt112: "The GoodWe PLUS+ membership comes with attractive benefits",
						plusbt113: "Explore More",
						plusbt12: "Qualification Criteria",
						plusbt122: "Step-by-step to GoodWe PLUS+ qualification",
						plusbt123: "Start Now",
						plusbt13: "Frequently Asked Questions",
						plusbt132: "Our FAQ section contains further details about the qualification process",
						plusbt133: "View More",
						plusbt2: "ABOUT GOODWE SOLAR ACADEMY",
						plusbt21: "We are aiming to provide pre-sales support beyond expectation and build an open platform for knowledge sharing and technical training in the PV industry globally.",
						stayin: "STAY IN THE LOOP!",
						stayin2: "Sign up for our newsletter. We won't spam you. Just one update per month.",
						stayin3: "Please enter an email address",
						stayin4: "Submit"
					}
				},
				xinzengde:{
					Username:'User name',
					OrganizationNa:'Organization Na',
					SEMSCode:'SEMS+ Code',
					LastReply:'Last Reply',
					ViewAnswers:'View Answers',
					ExamResults:'Exam Results',
					Back:'Back'
				},
				tuijian:{
					pone1_1:'CALCULATOR',
					pone1_2:'Achieve your energy independence',
					pone1_3:'Start',
					pone2_1:'Grid Voltage',
					pone2_2:'In this step, you will choose the hybrid inverter model',
					pone2_3:'Confirm',
					pone2_4:'Having trouble?',
					pone2_5:'Feel free to contact us and we will always help you through the process.',
					pone2_6:'Contact us',
					pone3_1:'Load Table',
					pone3_2:'Select the desired equipment from the options in the catalog and specify the quantity, or enter it manually if necessary.',
					pone3_3:'Autonomy',
					pone3_4:'Power',
					pone3_5:'Watts',
					pone3_6:'Add',
					pone3_7:'TOTAL',
					pone3_8:'Total Power',
					pone3_9:'Total Consumption',
					pone3_10:'Confirm',
					pone4_1:'Results',
					pone4_2:'Next, you will see some recommendations for Inverters and the  chosen Battery.',
					pone4_3:'Recommended Inverter',
					pone4_2:'Next, you will see some recommendations for Inverters and the  chosen Battery.',
					pone4_6:'Product detail',
					pone4_4:'Quantity',
					pone4_5:'Battery',
					pone4_7:'Print'
				},
				forum: {
					Search: "Search",
					Post: "Post",
					AllGroups: "All Groups",
					GettingStarted: "Getting Started",
					Official: "Official posts",
					Resource: "Learning Lab",
					Allposts: "All posts",
					Mypicks: "My picks",
					By: "By",
					Created: "Created",
					Lastreply: "Last reply",
					like: "Like",
					favorite: "Favorite",
					reward: "reward",
					previous: "Previous",
					next: "Next",
					Comment: "Comment",
					retract: "retract",
					more: "more",
					AllComment: "All Comment",
					Reward: "Reward",
					CurrentPoints: "Current Points",
					Ifyou: "If you like this post, you can reward the author with points",
					Title: "Title",
					pleasetitle: "please enter title",
					postto: "post to",
					pleaseselect: "please select",
					selectgroup: "click to select group",
					setreward: "set reward points",
					setup: "set up",
					currentpoints: "current points",
					content: "content",
					attachment: "attachment",
					add: "add",
					Supportedfile: "Supported file",
					draftbox: "draft box",
					//管理员
					shanchupinlun:'Delete',
					yincanpinlun:'Hide',
					zhidingpinlun:'Top'
			
				},
				resource: {
					sousuo1: 'Search keywords',
					sousuo2: 'Explore GoodWe Community Learning Lab right now !',
					videoPlaylists: 'Playlists',
					videofullplaylist: 'View full playlist',
					videoLanguage: 'Language',
					videoCountry: 'Country',
					videoProduct: 'Product',
					videoType: 'Type',
					videoRelatedProducts: 'Related Products',
					videoPopularSolutions: "Popular Solutions",
					videoTrendingVideos: "Trending Videos",
					videoAllvideo: "All video",
					videoPlaylistdetail: "Playlist-detail",
					Search:'Search',
				},
				activity: {
					toptitle:'Become a GoodWe ESA ',
					toptitlex:'Master Service Partner ',
					toptitle2:'Get certified to commission and maintain GoodWe ESA C&I energy storage systems (125kW / 261kWh) ',
					toptitle3:'The GoodWe ESA Master Service Partner Certification validates your expertise in commissioning, maintaining, and repairing GoodWe’s commercial and industrial energy storage systems. Certified partners are recognized as trusted service providers capable of delivering the highest standard of technical service.',
					topbtn:'Start Your Certification ',
					topbtn2:'*Active GoodWe PLUS+ membership required ',
					Whattoptitle:'WHAT IS THE MASTER SERVICE PARTNER',
					Whattoptitle2:'CERTIFICATION?',
					Validatetitle:'Validate Your Expertise',
					Validateneirong:'Demonstrate that your team has mastered GoodWe ESA commissioning, maintenance, and safety protocols through rigorous theory and practical evaluation.',
					Validatetitle2:'Advance Your Business',
					Validateneirong2:'Distinguish your company as a certified service partner. Customers trust Master Service Partners to deliver professional, safe, and reliable ESA system support.',
					Validatetitle3:'Unlock Rewards',
					Validateneirong3:'Earn GoodWe PLUS+ points for certified commissioning and maintenance activities. Redeem points for awards, training, and other benefits.',
					CERTIFICATIONtop:'CERTIFICATION JOURNEY',
					CERTItitle:'Pre-requisite',
					CERTIneirong:'Join GoodWe PLUS+ and complete the required ESA training program',
					CERTItitle2:'Theory Exam',
					CERTIneirong2:'Take the online exam via the GoodWe PLUS+ community (80% pass mark required)',
					CERTItitle3:'Practical Evaluation',
					CERTIneirong3:'Demonstrate your skills during an actual ESA commissioning under GoodWe expert supervision',
					CERTItitle4:'Get Certified',
					CERTIneirong4x:'Receive your certificate (valid for 1 year) and start performing certified work',
					CERTItitle5:'*During the exam, the candidate will need to provide the following information: full name of the candidate, ',
					CERTItitle6:'company name, SEMS organisation code of the company, and SEMS email address of the company.',
					SERVICEtitle:'WHAT YOU CAN DO AS A MASTER',
					SERVICEtitlexx:'SERVICE PARTNER',
					SERVICEtitle2:'Once certified, your company is authorized to perform:',
					SERVICEtitlex:'First commissioning of GoodWe ESA systems',
					SERVICEtitlex2:'Routine and corrective maintenance',
					SERVICEtitlex3:'Component replacement (including batteries, PCS, distribution box components, cooling units, and fire protection components)',
					SERVICEtitlex4:'Firmware updates via USB or IoT',
					SERVICEtitlex5:'System acceptance and sign-off on behalf of GoodWe',
					SERVICEtitlex6:'Note: All work must be performed in accordance with the GoodWe ESA Master Service Partner Standard Operating Procedure (SOP).',
					Questionstoptitle:'Frequently Asked Questions',
					Questionsquestions:' What are the prerequisites for the certification? ',
					Questionshuida:'You must join GoodWe PLUS+ and complete the required ESA training program before you can take the certification exam. ',
					Questionsquestions1:' How long is the certification valid? ',
					Questionshuida1:'The Master Service Partner certification is valid for 1 year from the date of issuance. ',
					Questionsquestions2:' What does the practical evaluation involve? ',
					Questionshuida2:'The practical evaluation requires demonstrating your skills during an actual ESA commissioning under GoodWe expert supervision. ',
					Questionsquestions3:' How do I earn rewards as a certified partner? ',
					Questionshuida3:'You earn GoodWe PLUS+ points for certified commissioning and maintenance activities, which can be redeemed for awards and training. ',
					Questionsquestions4:' What systems can I work on after certification? ',
					Questionshuida4:'As a certified partner, you can perform first commissioning, routine maintenance, and component replacement on GoodWe ESA systems. ',
					Questionsquestions5:' Is there ongoing support for certified partners? ',
					Questionshuida5:'Yes, certified partners have access to the GoodWe PLUS+ community and ongoing technical support resources. ',
					Questionsquestions6:' How often do I need to recertify? ',
					Questionshuida6:'Certification must be renewed annually to maintain your Master Service Partner status. ',
					
					Certifiedtitle:'Ready to Get Certified?',
					Certifiedtitle2:'Start your journey today. Take the first step by logging into the GoodWe PLUS+ community and ',
					Certifiedtitle2x:'accessing the certification exam.',
					Certifiedtitle3:'Start Your Certificatio',
					Certifiedtitle4:'Questions? Contact the GoodWe Service Team: service@goodwe.com'
				},
				plus: {
					JoinGOODWE: "Join GOODWE PLUS+",
					NotaMember: "Not a Member? Join Us",
					Alreadya: "Already a Member? Login",
					MasterServicePartner: "Master Service Partner",
					NOTAMEMBERYET: "NOT A MEMBER YET? GET QUALIFIED.",
					PREPARE: "PREPARE",
					LoginwithSEMS: "Login with SEMS+ Account",
					NewtoSEMS: "New to SEMS+? ",
					Register: 'Register',
					nowandjoin:" now and join us!",
					
					Loginnow: "Login now",
					UseaSEMS: "Use a SEMS+ Installer Organization representative account",
					Qualify: "SIGN UP",
					PasstheExam: "One Click to Unlock Membership",
					LearnFirst: "Learn First: Explore the ",
					LearnFirst2: "GoodWe PLUS+ Exam Preparation Playlist",
					StartExam: "Sign Up",
					OnlySEMS: "Only SEMS+ Installers Are Eligible for This Program",
					QualifyFor: "Qualify For Membership Today",
					BySuccessfully: "By Successfully Passing the Exam",
					WHYBECOME: "WHY BECOME A GOODWE PLUS+",
					INSTALLERCOMPANY: "INSTALLER COMPANY?",
					AGlobalProgram: "A Global Program for Exclusive Installer Benefits",
					QUALIFY: "SIGN UP",
					Passthecert: "One simple click for membership",
					INSTALL: "INSTALL",
					InstallGoodWe: "Install GoodWe product",
					EARN: "CLAIM",
					Earnpoints: "Provide device model type and SN to claim points, get cashback!",
					UPGRADE: "UPGRADE&REDEEM",
					Upgradeyour: "Upgrade your membership and unlock exclusive member benefits",
					Preparefor: "GoodWe PLUS+ ",
					withLearning: "LEARNING RESOURCE",
					Allexamcontent: "Enrich your technical skills with GoodWe PLUS+ exclusive learning resources. Please visit the video playlist to select courses for your region and language.",
					LearnMore: "Learn More",
					GWPlus: "GW Plus+ FAQ ", // 没有
					Goodmorning: "Good morning",
					Hello: "Hello: ",
					Yourcurrent: "Your current status is:",
					Youneed: ". You need ",
					pointstoachieve: "points to achieve the next level. Your current status will be expired: ",
					Currentstatus: "Current status",
					SEMSOrganization: "SEMS+ Organization Code", // 没有
					Email: "Email",
					Validuntil: "Valid until end of ",
					pointsearned: "points earned",
					Updatedatthe: "Updated at the start of each month",
					Clickonthe: "Click on the top to enter the points details",
					putong: ['Upgrade to SILVER tier by earning ',
						'points by the end of the year. Upgrade to GOLD tier by earning a total of',
						' points by the end of the year.'
					],
					yinpai: ['Upgrade to GOLD tier by earning a total of ',
						'points by the end of the year. Retain SILVER tier by earning a total of',
						' points by the end of the year.'
					],
					jinpai: ['Achieve SILVER tier by earning a total of ',
						'points by the end of the year. Retain to GOLD tier by earning a total of',
						' points by the end of the year.'
					],
					Promotionalmaterials: "Promotional materials",
					Certificate: "Certificate",
					Howtoearn: "How to earn points",
					RedeemyourGood: "Redeem your GoodWe PLUS+ points",
					RedeemyourGood2: "Collect your GoodWe PLUS+ points here!",
					points: "points",
					Alreadyredeemed: "Already redeemed",
					Clickonthe: "Click on the circle to enter the points details",
					Totalredeemable: "Total redeemable points collected during validity period:",
					InstallationRecord: "Installation Record",
					DATE: "DATE",
					MODELTYPE: "MODEL TYPE",
					CAPACITY: "CAPACITY",
					NUMBER: "NUMBER",
					POINTS: "POINTS",
				},
				Promotion:{
					title:'HOW TO PARTICIPATE?',
					title1:"JOIN GOODWE PLUS+",
					title2:"UPLOAD DOCUMENTS",
					title3:'RECEIVE REBATE',
					joinstep:'STEP',
					joinneirong1:'Visit our website',
					joinneirong12:' [GoodWe PLUS+ Program] ',
					joinneirong13:'and follow the instructions to become a GoodWe PLUS+ member.',
					joinneirong2:'After completing the installation of Lynx U G3 batteries, upload the purchase invoices, installation reports, and other required documents to our designated platform.',
					joinn2from:{
						Name:'Name',
						City:'City',
						Country:'Country',
						Zip:'Zip',
						CompanyName:'Company Name',
						StreetHousenumber:'Street and Housenumber',
						Email:'Email',
						Phone:'Phone',
						IBAN:'IBAN',
						BIC:'BIC',
						purchaseddevices:'Serial no. of new purchased devices',
						recogniseddevices:'Serial no. of recognised devices',
						Purchaseorder:'Purchase order',
						Amount:'Amount',
						Submit:'Submit'
					},
					// joinneirong3:'Once the documents are verified, the 140 - euro rebate per battery will be credited to your account within [30] business days.',
					joinneirong3:'Once the documents are verified, the €140 rebate per battery will be credited to your account within six weeks, and the warranty for each Lynx U G3 battery installed under this promotion will also be extended by one year within the same period.',
					join4biaoti:'Membership Requirement',
					join4biaoti1:'Rebate Mechanism',
					join4neirong:'Once joined, installers can upload necessary purchase orders and installation records. Meanwhile, the installer will receive an email as proof of participation. After verification, we will provide a rebate of 140 euros for each Lynx U G3 battery installed. This rebate not only helps to offset the cost of the additional batteries but also rewards our partners for their continued support and excellent service.',
					join4biaoti2:'Benefits of Lynx U G3',
					LearnMore :'Learn More '
				},
				Personal: {
					Address: 'Address',
					zuolies:["Profile", "Notification", "Posts", "Webinar", "My points"],
					Submit: 'Enviar',
					Posts: 'Posts',
					MyPicks: 'My Picks',
					profile: 'profile',
					Personalinformation: 'Personal information',
					UserName: 'User Name',
					Country: 'Country/Region',
					language: 'language',
					// Region:'Region',
					Email: 'Email',
					Organization: 'Organization',
					JobTitle: 'JobTitle',
					semscode: 'semscode',
					registered: 'Registered',
					date: 'date',
					action: 'action',
					points: 'Points',
					InstallEquipment: 'Install Equipment',
					EarnedfromForum: 'Earned from Forum',
					UsedforReward: 'Used for Reward',
					UsedforRedemption: 'Used for Redemption',
					PointsExpired: 'Points Expired',
				},
				PointsMall: {
					mypoints: 'My points:',
					Entity: 'Entity',
					Extendedwarranty: 'Extended warranty',
					Inventoryshortage: 'Inventory shortage',
					shippingaddress: 'Please select your shipping address',
					Shippinginformation: 'Shipping information',
					DAddress: 'Default Address',
					Modify: 'Modify',
					Addreceivingaddress: 'Add receiving address',
					Addnewaddress: 'Add new address',
					CountryRegion: 'Country/Region:',
					DetailedAddress: 'Detailed Address:',
					Receiver: 'Receiver :',
					Tel: 'Tel:',
					Email: 'Email:',
					Setasdefaultaddress: 'Set as default address',
					Cancel: 'Cancel',
					Edit: 'Edit' [{}],
					Delete: 'Delete',
					Warrantyextensionpurchase: 'Warranty extension purchase',
					DEVICESERIALNUMBER: 'DEVICE SERIAL NUMBER',
					LIMITEDWARRANTY: 'LIMITED WARRANTY',
					Warrantyextensionoption: 'Warranty extension option',
					Pleaseextension: 'Please click here to choose suitable warranty extension year.',
					Pricepoint: 'Price(point)',
					Youraccount: 'Your account',
					Redeem: 'Redeem'
				},
				Exam: {
					ExamDetails: 'Exam Details',
					Cancel: 'CANCEL',
					QuestionType: 'Question Type：',
					QuestionType2: 'Multiple-choice and true/false questions.',
					FullScore: 'Full Score',
					FullScore2: ' 100 points',
					PassingScore: 'Passing Score',
					PassingScore2: ' 80 points or above',
					Attempts: 'Attempts',
					Attempts2: 'Unlimited attempts allowed',
					Interruption: 'Interruption',
					Interruption2: 'If you exit midway, you will need to restart the exam',
					gotit: 'I got it',
					exambiaoti: 'GoodWe PLUS+ Membership Exam System',
					exambiaoti1: 'Pass the exam to become a GoodWe PLUS+ member and unlock more exclusive membership benefits!',
					exambiaoti3: 'Start Exam',
					exambiaoti4: "Not Ready? Study more",
					exam2Next: 'Next',
					exam2Submit: 'Submit',
					exam2Congratulations: 'Congratulations!',
					exam2PLUS: 'You are now a GoodWe PLUS+ Member!',
					exam2Thankyou: 'Thank you for participating! Now you can explore exclusive member benefits and unlock more exciting content.',
					exam2GotoMember: 'Go to Member-Exclusive Page',
					exam2Benefits: 'Explore More Benefits',
					exam2pass: 'You did not pass.',
					exam2quiz: 'Sorry, you did not pass the quiz',
					exam2Finish: 'Finish',
					exam2Try: 'Try Again'
				},
				Logins:{
					LogInWithYourAccount:'Log In With Your Account',
					Donthaveanaccountyet:'Don`t have an account yet?',
					SignupasEndUser:'Sign up SEMS',
					SignupasInstaller:'Sign up as Installer'
				}
				
			},
		},
		cunyuanyan: {},
		//切换语言固定文字
	},
	mutations: {
		gaiquanxian(state, shu) {
			state.quanxian = shu;
		},
		gaizongquanxian(state, shu) {
			state.zongquanxian = shu;
			state.SAAS = shu.SAAS;
		},
		gaiyonghu(state, shu) {
			state.yonghu = shu;
		},
		// 改变语言
		Gaiyuyan(state, shu) {
			state.yuyan = shu;
			state.cunyuanyan = state.xinyuyan[state.yuyan];
			// console.log(shu)
			// console.log(9999)
		}
	},
	actions: {
		huoquzongquanxian(context) {
			if (!context.state.zongquanxian.id || context.state.zongquanxian.id.length == 0) {
				zongquanxianlie().then(shu => {
					context.commit('gaizongquanxian', shu.shu)
				})
			}
		},
		huoququanxian(context) {
			// if(!context.state.quanxian.id || context.state.quanxian.id.length==0){
			quanxianlie().then(shu => {
				context.commit('gaiquanxian', shu.shu)
			})
			// }
		}
	}
})